import React from "react";

import { MaterialTooltip } from "src/app/components/MaterialTooltip/MaterialTooltip";
import { Button } from "src/app/components/Button/Button";
import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import { MAX_CREATORS_FOR_GENERATE_SHOWCASE } from "src/app/CreatorShowcase/utils";
import TypeIcon from "../../../components/ExportTypes/TypeIcon";

export default function DownloadInPDFButton({
  exportList,
  selectedInfluencers,
}) {
  return (
    <MaterialTooltip
      content={
        <IDHFormattedMessage
          id="front_cannot_generate_showcase"
          defaultMessage="Cannot generate showcase for more than 100 creators"
        />
      }
      contentHidden={
        selectedInfluencers.length <= MAX_CREATORS_FOR_GENERATE_SHOWCASE
      }
    >
      <Button
        size="medium"
        variant="white"
        onClick={() => exportList("pdf")}
        data-export-type="pdf"
        data-qa="download-in-pdf-button"
        disabled={
          selectedInfluencers.length > MAX_CREATORS_FOR_GENERATE_SHOWCASE
        }
      >
        <TypeIcon type="pdf" />
        <IDHFormattedMessage
          id="front_download_in"
          defaultMessage="Download in"
        />
      </Button>
    </MaterialTooltip>
  );
}
